/* Zheytin temporary launch page. Remove with the launch template. */

(function(){
  var wrap = document.querySelector('.zh-page');
  if (!wrap) return;

  var launch = new Date(wrap.getAttribute('data-launch'));
  if (isNaN(launch.getTime())) {
    launch = new Date();
    launch.setDate(launch.getDate() + 98);
  }

  var els = {
    d: document.querySelector('[data-zh="d"]'),
    h: document.querySelector('[data-zh="h"]'),
    m: document.querySelector('[data-zh="m"]'),
    s: document.querySelector('[data-zh="s"]')
  };
  if (!els.d || !els.h || !els.m || !els.s) return;

  function pad(n) { return String(n).padStart(2, '0'); }
  var prev = { d: null, h: null, m: null, s: null };

  function tick() {
    var diff = Math.max(0, launch - Date.now());
    var d = pad(Math.floor(diff / 86400000));
    var h = pad(Math.floor((diff % 86400000) / 3600000));
    var m = pad(Math.floor((diff % 3600000) / 60000));
    var s = pad(Math.floor((diff % 60000) / 1000));
    if (d !== prev.d) { els.d.textContent = d; prev.d = d; }
    if (h !== prev.h) { els.h.textContent = h; prev.h = h; }
    if (m !== prev.m) { els.m.textContent = m; prev.m = m; }
    if (s !== prev.s) { els.s.textContent = s; prev.s = s; }
    if (!diff) clearInterval(timer);
  }

  tick();
  var timer = setInterval(tick, 1000);

  function initAnim() {
    if (typeof gsap === 'undefined') return setTimeout(initAnim, 150);

    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var D  = rm ? 0.01 : 1;
    var S  = rm ? 0    : 0.028;

    function splitEl(el) {
      var nodes  = Array.from(el.childNodes);
      var frag   = document.createDocumentFragment();
      var allChars = [];

      nodes.forEach(function(node) {
        if (node.nodeType === 3) {
          var txt = node.textContent;
          if (!txt.trim()) {
            if (txt.indexOf(' ') !== -1) frag.appendChild(document.createTextNode(' '));
            return;
          }
          var leading  = txt.match(/^\s/);
          var trailing = txt.match(/\s$/);
          if (leading) frag.appendChild(document.createTextNode(' '));
          txt.trim().split(' ').forEach(function(word, wi, arr) {
            var wSpan = document.createElement('span');
            wSpan.className = 'zh-word';
            for (var i = 0; i < word.length; i++) {
              var c = document.createElement('span');
              c.className = 'zh-char';
              c.textContent = word[i];
              wSpan.appendChild(c);
              allChars.push(c);
            }
            frag.appendChild(wSpan);
            if (wi < arr.length - 1) frag.appendChild(document.createTextNode(' '));
          });
          if (trailing) frag.appendChild(document.createTextNode(' '));
        } else if (node.nodeType === 1) {
          if (node.tagName === 'BR') { frag.appendChild(node.cloneNode()); return; }
          var wrapper = node.cloneNode(false);
          node.textContent.trim().split(' ').forEach(function(word, wi, arr) {
            var wSpan = document.createElement('span');
            wSpan.className = 'zh-word';
            for (var i = 0; i < word.length; i++) {
              var c = document.createElement('span');
              c.className = 'zh-char';
              c.textContent = word[i];
              wSpan.appendChild(c);
              allChars.push(c);
            }
            wrapper.appendChild(wSpan);
            if (wi < arr.length - 1) wrapper.appendChild(document.createTextNode(' '));
          });
          frag.appendChild(wrapper);
        }
      });

      el.innerHTML = '';
      el.appendChild(frag);
      return allChars;
    }

    var titleEl = document.querySelector('[data-zh-split]');
    if (!titleEl) return;

    var chars = splitEl(titleEl);
    titleEl.style.opacity = '1';

    var logo      = document.querySelector('.zh-logo-mask');
    var eyebrow   = document.querySelector('.zh-eyebrow');
    var eyeLineL  = document.querySelector('.zh-eyebrow__line--left');
    var eyeLineR  = document.querySelector('.zh-eyebrow__line--right');
    var perksIntro = document.querySelector('.zh-perks__intro');
    var perksTop   = document.querySelector('.zh-perks__top-badge');
    var perksRow   = document.querySelector('.zh-perks__row');
    var perksBadge = document.querySelector('.zh-perks__badge');
    var units      = document.querySelectorAll('.zh-unit');
    var scroll     = document.querySelector('.zh-scroll-wrap');

    var animated = [logo, eyebrow, eyeLineL, eyeLineR, perksIntro, perksTop, perksRow, perksBadge, scroll];
    units.forEach(function(u) { animated.push(u); });
    chars.forEach(function(c) { animated.push(c); });
    animated.forEach(function(el) { if (el) el.style.willChange = 'opacity, transform'; });

    var tl = gsap.timeline({
      delay: 0.3,
      onComplete: function() {
        animated.forEach(function(el) { if (el) el.style.willChange = 'auto'; });
      }
    });

    tl.fromTo(logo,
      { opacity: 0, scale: 0.92 },
      { opacity: 0.94, scale: 1, duration: D * 0.9, ease: 'power2.out' }, 0);

    tl.fromTo(eyebrow,
      { opacity: 0 },
      { opacity: 1, duration: D * 0.5, ease: 'power2.out' }, 0.2);

    tl.to(eyeLineL, { scaleX: 1, duration: D * 0.7, ease: 'power3.out' }, 0.3);
    tl.to(eyeLineR, { scaleX: 1, duration: D * 0.7, ease: 'power3.out' }, 0.3);

    tl.to(chars, {
      opacity: 1, y: 0,
      stagger: S, duration: D * 1.1, ease: 'expo.out'
    }, 0.35);

    tl.fromTo(perksIntro,
      { opacity: 0, y: 12 },
      { opacity: 1, y: 0, duration: D * 0.6, ease: 'power2.out' }, 0.68);

    tl.fromTo(perksTop,
      { opacity: 0, y: 8 },
      { opacity: 1, y: 0, duration: D * 0.5, ease: 'power2.out' }, 0.74);

    tl.fromTo(perksRow,
      { opacity: 0, y: 14 },
      { opacity: 1, y: 0, duration: D * 0.8, ease: 'power2.out' }, 0.80);

    tl.fromTo(perksBadge,
      { opacity: 0 },
      { opacity: 1, duration: D * 0.5, ease: 'power2.out' }, 0.96);

    tl.to(units, {
      opacity: 1, y: 0,
      stagger: 0.08, duration: D * 0.6, ease: 'power2.out'
    }, 1.0);

    tl.to(scroll, {
      opacity: 1, duration: D * 0.5, ease: 'power2.out'
    }, 1.30);
  }

  if (document.readyState === 'complete') {
    initAnim();
  } else {
    window.addEventListener('load', initAnim, { once: true });
  }
})();



(function(){
  function initZHP() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      return setTimeout(initZHP, 150);
    }
    gsap.registerPlugin(ScrollTrigger);

    var section = document.querySelector('[data-zhp="section"]');
    if (!section) return;

    var rm        = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isDesktop = window.innerWidth >= 1024;
    var D = rm ? 0.01 : 1;
    var S = rm ? 0    : 0.028;

    /* ── Character split via DocumentFragment — single reflow ── */
    function splitEl(el) {
      var nodes    = Array.from(el.childNodes);
      var frag     = document.createDocumentFragment();
      var allChars = [];

      nodes.forEach(function(node) {
        if (node.nodeType === 3) {
          var txt = node.textContent;
          if (!txt.trim()) {
            if (txt.indexOf(' ') !== -1) frag.appendChild(document.createTextNode(' '));
            return;
          }
          var leading  = txt.match(/^\s/);
          var trailing = txt.match(/\s$/);
          if (leading) frag.appendChild(document.createTextNode(' '));
          txt.trim().split(' ').forEach(function(word, wi, arr) {
            var wSpan = document.createElement('span');
            wSpan.className = 'zhp-word';
            for (var i = 0; i < word.length; i++) {
              var c = document.createElement('span');
              c.className = 'zhp-char';
              c.textContent = word[i];
              wSpan.appendChild(c);
              allChars.push(c);
            }
            frag.appendChild(wSpan);
            if (wi < arr.length - 1) frag.appendChild(document.createTextNode(' '));
          });
          if (trailing) frag.appendChild(document.createTextNode(' '));
        } else if (node.nodeType === 1) {
          var wrapper = node.cloneNode(false);
          node.textContent.trim().split('').forEach(function(ch) {
            var c = document.createElement('span');
            c.className = 'zhp-char';
            c.textContent = ch;
            wrapper.appendChild(c);
            allChars.push(c);
          });
          frag.appendChild(wrapper);
        }
      });

      el.innerHTML = '';
      el.appendChild(frag); /* Single DOM write */
      return allChars;
    }

    var heading  = section.querySelector('[data-zhp-split]');
    var chars    = splitEl(heading);

    var eyebrow  = section.querySelector('.zhp-eyebrow');
    var eyeLineL = section.querySelector('.zhp-eyebrow__line--left');
    var eyeLineR = section.querySelector('.zhp-eyebrow__line--right');
    var desc     = section.querySelector('.zhp-desc');
    var volumes  = section.querySelector('.zhp-volumes');
    var volLineL = section.querySelector('.zhp-volumes__line--left');
    var volLineR = section.querySelector('.zhp-volumes__line--right');
    var infoRow  = section.querySelector('.zhp-info-row');

    var orangeCard = section.querySelector('[data-zhp-card="orange"]');
    var greenCard  = section.querySelector('[data-zhp-card="green"]');
    var purpleCard = section.querySelector('[data-zhp-card="purple"]');
    var orangeImg  = orangeCard ? orangeCard.querySelector('.zhp-card-img') : null;
    var greenImg   = greenCard  ? greenCard.querySelector('.zhp-card-img')  : null;
    var purpleImg  = purpleCard ? purpleCard.querySelector('.zhp-card-img') : null;

    /* Set will-change only for anim duration, clear after */
    var animated = [eyebrow, desc, volumes, infoRow, orangeCard, greenCard, purpleCard];
    chars.forEach(function(c) { animated.push(c); });
    if (isDesktop) { [orangeImg, greenImg, purpleImg].forEach(function(i) { if (i) animated.push(i); }); }
    animated.forEach(function(el) { if (el) el.style.willChange = 'opacity, transform'; });

    var tl = gsap.timeline({
      scrollTrigger: { trigger: section, start: 'top 72%', once: true },
      onComplete: function() {
        /* Free compositor layers after animation finishes */
        animated.forEach(function(el) { if (el) el.style.willChange = 'auto'; });
      }
    });

    tl.to(eyebrow,  { opacity: 1, duration: D * 0.5, ease: 'power2.out' }, 0);
    tl.to(eyeLineL, { scaleX: 1,  duration: D * 0.7, ease: 'power3.out' }, 0.1);
    tl.to(eyeLineR, { scaleX: 1,  duration: D * 0.7, ease: 'power3.out' }, 0.1);
    tl.to(chars, { opacity: 1, y: 0, stagger: S, duration: D * 1.1, ease: 'expo.out' }, 0.15);
    tl.fromTo(desc,    { opacity: 0, y: 22 }, { opacity: 1, y: 0, duration: D * 0.8, ease: 'power2.out' }, 0.55);
    tl.fromTo(volumes, { opacity: 0 },        { opacity: 1,       duration: D * 0.5, ease: 'power2.out' }, 0.7);
    tl.to(volLineL, { scaleX: 1, duration: D * 0.6, ease: 'power3.out' }, 0.75);
    tl.to(volLineR, { scaleX: 1, duration: D * 0.6, ease: 'power3.out' }, 0.75);
    tl.to(infoRow,  { opacity: 1, y: 0, duration: D * 0.7, ease: 'power2.out' }, 0.85);

    if (isDesktop) {
      tl.to(greenCard,  { opacity: 1, y: -52, duration: D * 0.7, ease: 'power2.out' }, 1.05);
      tl.to(orangeCard, { opacity: 1, y: 0,   duration: D * 0.7, ease: 'power2.out' }, 1.15);
      tl.to(purpleCard, { opacity: 1, y: 0,   duration: D * 0.7, ease: 'power2.out' }, 1.25);

      var riseAmt  = 28;
      var riseDur  = D * 0.5;
      var riseEase = 'power2.out';
      var fallDur  = D * 0.4;
      var fallEase = 'power2.inOut';

      tl.to(greenImg,  { y: -riseAmt, duration: riseDur, ease: riseEase }, '+=0.15');
      tl.to(greenImg,  { y: 0,        duration: fallDur, ease: fallEase });
      tl.to(orangeImg, { y: -riseAmt, duration: riseDur, ease: riseEase }, '>-0.15');
      tl.to(orangeImg, { y: 0,        duration: fallDur, ease: fallEase });
      tl.to(purpleImg, { y: -riseAmt, duration: riseDur, ease: riseEase }, '>-0.15');
      tl.to(purpleImg, { y: 0,        duration: fallDur, ease: fallEase });

    } else {
      var cardOrder = [greenCard, orangeCard, purpleCard];
      cardOrder.forEach(function(card, i) {
        if (!card) return;
        tl.to(card, { opacity: 1, y: 0, duration: D * 0.65, ease: 'power2.out' }, 1.05 + i * 0.14);
      });
    }
  }

  /* Wait for GSAP (loaded via defer on the hero) to be available */
  if (document.readyState === 'complete') {
    initZHP();
  } else {
    window.addEventListener('load', initZHP, { once: true });
  }
})();



(function() {
  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      return setTimeout(init, 150);
    }
    gsap.registerPlugin(ScrollTrigger);

    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var D = rm ? 0.01 : 1;
    var S = rm ? 0 : 0.025;

    /* ── Character split via DocumentFragment — single DOM write per heading ── */
    function splitChars(el) {
      var nodes    = Array.from(el.childNodes);
      var frag     = document.createDocumentFragment();
      var allChars = [];

      nodes.forEach(function(node) {
        if (node.nodeType === 3) {
          var txt = node.textContent;
          if (!txt.trim()) {
            if (txt.indexOf(' ') !== -1) frag.appendChild(document.createTextNode(' '));
            return;
          }
          var leading  = txt.match(/^\s/);
          var trailing = txt.match(/\s$/);
          if (leading) frag.appendChild(document.createTextNode(' '));
          txt.trim().split(' ').forEach(function(word, wi, arr) {
            var wSpan = document.createElement('span');
            wSpan.className = 'zhs-word';
            for (var i = 0; i < word.length; i++) {
              var c = document.createElement('span');
              c.className = 'zhs-char';
              c.textContent = word[i];
              wSpan.appendChild(c);
              allChars.push(c);
            }
            frag.appendChild(wSpan);
            if (wi < arr.length - 1) frag.appendChild(document.createTextNode(' '));
          });
          if (trailing) frag.appendChild(document.createTextNode(' '));
        } else if (node.nodeType === 1) {
          var wrapper = node.cloneNode(false);
          node.textContent.trim().split('').forEach(function(ch) {
            var c = document.createElement('span');
            c.className = 'zhs-char';
            c.textContent = ch;
            wrapper.appendChild(c);
            allChars.push(c);
          });
          frag.appendChild(wrapper);
        }
      });

      el.innerHTML = '';
      el.appendChild(frag); /* Single DOM write */
      return allChars;
    }

    /* ── HERO ── */
    var hero = document.querySelector('[data-zhs="hero"]');
    if (hero) {
      var heading = hero.querySelector('[data-zhs-split]');
      var chars   = splitChars(heading);
      var eye     = hero.querySelector('.zhs-hero__eyebrow');
      var scroll  = hero.querySelector('.zhs-scroll');

      /* Set will-change before animation, clear after to free GPU memory */
      var heroEls = [eye, scroll].concat(chars);
      heroEls.forEach(function(el) { if (el) el.style.willChange = 'opacity, transform'; });

      gsap.set(eye,    { opacity: 0, y: 20 });
      gsap.set(scroll, { opacity: 0 });

      var tl = gsap.timeline({
        delay: 0.35,
        onComplete: function() {
          heroEls.forEach(function(el) { if (el) el.style.willChange = 'auto'; });
        }
      });
      tl.to(eye,    { opacity: 1, y: 0, duration: D * 0.7, ease: 'power2.out' }, 0);
      tl.to(chars,  { opacity: 1, y: 0, stagger: S, duration: D * 1.1, ease: 'expo.out' }, 0.15);
      tl.to(scroll, { opacity: 1, duration: D * 0.5 }, 0.7);
    }

    /* ── CHAPTERS ── */
    document.querySelectorAll('[data-zhs="chapter"]').forEach(function(ch) {
      var title   = ch.querySelector('[data-zhs-split]');
      var chars   = splitChars(title);
      var eye     = ch.querySelector('.zhs-ch__eyebrow');
      var eyeLine = ch.querySelector('.zhs-ch__eyebrow-line');
      var body    = ch.querySelector('.zhs-ch__body');
      var stats   = ch.querySelector('.zhs-ch__stats');
      var counter = ch.querySelector('.zhs-ch__counter');
      var clip    = ch.querySelector('.zhs-ch__img-clip');
      var img     = clip ? clip.querySelector('img') : null;
      var imgNum  = ch.querySelector('.zhs-ch__img-number');
      var scroll  = ch.querySelector('.zhs-scroll');

      /* Set will-change before animation, clear after */
      var animated = [eye, body, stats, counter, scroll, imgNum].concat(chars);
      if (eyeLine) animated.push(eyeLine);
      if (clip)    animated.push(clip);
      if (img)     animated.push(img);
      animated.forEach(function(el) { if (el) el.style.willChange = 'opacity, transform'; });

      gsap.set(eye,    { opacity: 0, y: 24 });
      if (eyeLine) gsap.set(eyeLine, { scaleX: 0 });
      if (counter) gsap.set(counter, { opacity: 0 });
      gsap.set(body,   { opacity: 0, y: 24 });
      if (stats)   gsap.set(stats,   { opacity: 0, y: 20 });
      if (scroll)  gsap.set(scroll,  { opacity: 0 });
      if (clip)    gsap.set(clip,    { clipPath: 'inset(100% 0 0 0)' });
      if (img)     gsap.set(img,     { scale: 1.08 });
      if (imgNum)  gsap.set(imgNum,  { opacity: 0 });

      var tl = gsap.timeline({
        scrollTrigger: { trigger: ch, start: 'top 75%', once: true },
        onComplete: function() {
          animated.forEach(function(el) { if (el) el.style.willChange = 'auto'; });
        }
      });

      if (counter) tl.to(counter, { opacity: 1, duration: D * 0.5 }, 0);
      if (eyeLine) tl.to(eyeLine, { scaleX: 1, duration: D * 0.6, ease: 'power2.out' }, 0);
      tl.to(eye,   { opacity: 1, y: 0, duration: D * 0.7, ease: 'power2.out' }, 0.05);
      tl.to(chars, { opacity: 1, y: 0, stagger: S, duration: D * 1, ease: 'expo.out' }, 0.1);
      tl.to(body,  { opacity: 1, y: 0, duration: D * 0.8, ease: 'power2.out' }, 0.4);
      if (stats)  tl.to(stats,  { opacity: 1, y: 0, duration: D * 0.6, ease: 'power2.out' }, 0.55);
      if (scroll) tl.to(scroll, { opacity: 1, duration: D * 0.5, ease: 'power2.out' }, 0.65);
      if (clip)   tl.to(clip,   { clipPath: 'inset(0% 0 0% 0)', duration: D * 1.3, ease: 'expo.inOut' }, 0.1);
      if (img)    tl.to(img,    { scale: 1, duration: D * 1.8, ease: 'power2.out' }, 0.25);
      if (imgNum) tl.to(imgNum, { opacity: 1, duration: D * 0.8 }, 0.5);
    });
  }

  /* window.load fires after everything is ready, {once} auto-removes the listener */
  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init, { once: true });
  }
})();



(function() {
  var section = document.querySelector('.zhfm');
  if (!section) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile     = window.innerWidth < 980;

  function initReveal() {
    var body = section.querySelector('[data-zhfm-type]');
    if (!body) return;
    body.classList.add('zhfm-body--reveal');
    body.removeAttribute('data-zhfm-type');
    body.style.minHeight = '0';

    var paragraphs = body.querySelectorAll('p');
    var signature  = section.querySelector('.zhfm-signature');

    paragraphs.forEach(function(p, i) {
      setTimeout(function() { p.classList.add('is-revealed'); }, 800 + i * 220);
    });
    if (signature) {
      setTimeout(function() { signature.classList.add('is-revealed'); }, 800 + paragraphs.length * 220 + 300);
    }
  }

  function initTyping() {
    var body = section.querySelector('[data-zhfm-type]');
    if (!body) return;

    var paragraphs = body.querySelectorAll('p');
    if (!paragraphs.length) return;

    var signature     = section.querySelector('.zhfm-signature');
    var naturalHeight = body.scrollHeight;
    body.style.height   = naturalHeight + 'px';
    body.style.overflow = 'hidden';

    var paraData = [];
    paragraphs.forEach(function(p) {
      paraData.push({ el: p, html: p.innerHTML });
      p.innerHTML = '';
      p.style.minHeight = '0';
    });

    var cursor = document.createElement('span');
    cursor.className = 'zhfm-cursor';

    function typeHTML(el, html, callback) {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var ops = [];

      function walk(node) {
        if (node.nodeType === 3) {
          for (var i = 0; i < node.textContent.length; i++) {
            ops.push({ type: 'char', char: node.textContent[i] });
          }
        } else if (node.nodeType === 1) {
          ops.push({ type: 'open', tag: node.tagName.toLowerCase(), node: node });
          for (var c = 0; c < node.childNodes.length; c++) walk(node.childNodes[c]);
          ops.push({ type: 'close' });
        }
      }
      for (var i = 0; i < temp.childNodes.length; i++) walk(temp.childNodes[i]);

      el.innerHTML = '';
      var stack = [el];
      var idx   = 0;

      function step() {
        if (idx >= ops.length) { if (callback) callback(); return; }
        var op     = ops[idx++];
        var parent = stack[stack.length - 1];
        if (op.type === 'char') {
          if (cursor.parentNode) cursor.parentNode.removeChild(cursor);
          parent.appendChild(document.createTextNode(op.char));
          parent.appendChild(cursor);
          setTimeout(step, 18);
        } else if (op.type === 'open') {
          var newEl = document.createElement(op.tag);
          for (var a = 0; a < op.node.attributes.length; a++) {
            newEl.setAttribute(op.node.attributes[a].name, op.node.attributes[a].value);
          }
          if (cursor.parentNode) cursor.parentNode.removeChild(cursor);
          parent.appendChild(newEl);
          stack.push(newEl);
          step();
        } else if (op.type === 'close') {
          stack.pop();
          step();
        }
      }
      step();
    }

    function typeAll(index) {
      if (index >= paraData.length) {
        setTimeout(function() {
          cursor.classList.add('zhfm-cursor--done');
          body.style.height  = '';
          body.style.overflow = '';
        }, 400);
        if (signature) setTimeout(function() { signature.classList.add('is-revealed'); }, 600);
        return;
      }
      typeHTML(paraData[index].el, paraData[index].html, function() {
        setTimeout(function() { typeAll(index + 1); }, 280);
      });
    }

    setTimeout(function() { typeAll(0); }, 1200);
  }

  if (reduceMotion) {
    section.classList.add('is-visible');
    var body = section.querySelector('[data-zhfm-type]');
    if (body) body.removeAttribute('data-zhfm-type');
    var sig = section.querySelector('.zhfm-signature');
    if (sig) sig.classList.add('is-revealed');
  } else {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        section.classList.add('is-visible');
        observer.unobserve(section);
        if (isMobile) { initReveal(); } else { initTyping(); }
      });
    }, { threshold: 0.12 });
    observer.observe(section);
  }
})();



(function(){
  var section = document.querySelector('.zhfc');
  if (section) {
    var targetCount = parseInt(section.dataset.currentCount, 10) || 0;
    var rm = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    function initCounter() {
      var tens = Math.floor(targetCount / 10), ones = targetCount % 10;
      function roll(el, val, d) {
        if (!el) return;
        setTimeout(function(){
          el.style.opacity = '0';
          el.style.filter = 'blur(2px)';
          el.style.transition = 'opacity .3s,filter .3s';
          setTimeout(function(){ el.textContent = val; el.style.opacity = '1'; el.style.filter = 'blur(0)'; }, 150);
        }, d);
      }
      roll(section.querySelector('[data-tens]'), tens, 400);
      roll(section.querySelector('[data-ones]'), ones, 600);
      var seats = section.querySelectorAll('.zhfc-seat'), sa = Array.from(seats).slice(0, targetCount), si = 0, st = null, dur = Math.min(targetCount * 8, 1000);
      function anim(ts) {
        if (!st) st = ts;
        var p = Math.min((ts - st) / dur, 1), t = Math.floor(p * targetCount);
        while (si < t) { sa[si].style.opacity = '1'; si++; }
        if (si === targetCount - 1) sa[si].classList.add('is-frontier');
        if (p < 1) requestAnimationFrame(anim);
      }
      sa.forEach(function(s){ s.style.opacity = '0'; });
      setTimeout(function(){ requestAnimationFrame(anim); }, 300);
      var bar = section.querySelector('.zhfc-progress-bar');
      if (bar) setTimeout(function(){ bar.style.width = targetCount + '%'; }, 800);
      var dots = section.querySelectorAll('.zhfc-progress-dots span'), ad = Math.ceil(targetCount / 20);
      dots.forEach(function(d, i){ if (i < ad) setTimeout(function(){ d.classList.add('active'); }, 1000 + i * 100); });
    }
    if (rm) { section.classList.add('is-visible'); initCounter(); }
    else {
      var obs = new IntersectionObserver(function(e){
        e.forEach(function(en){
          if (!en.isIntersecting) return;
          section.classList.add('is-visible');
          obs.unobserve(section);
          initCounter();
        });
      }, { threshold: .12 });
      obs.observe(section);
    }
  }

  /* Shopify Forms renders inside an open shadow root. Keep required markers
     visible even when custom-field labels are normalized to metafield names. */
  var shopifyFormsRequiredFields = [
    'first_name',
    'last_name',
    'email',
    'phone_number',
    'custom#application_motivation',
    'custom#olive_oil_purchase_frequency',
    'custom#olive_oil_use_frequency',
    'custom#primary_olive_oil_use',
    'custom#professional_chef',
    'custom#organic_non_gmo_importance',
    'custom#social_platform',
    'custom#social_handle'
  ];
  var observedShopifyFormRoots = new WeakSet();

  function markShopifyFormsRequiredFields(root) {
    shopifyFormsRequiredFields.forEach(function(name) {
      var field = root.querySelector('[name="' + name + '"]');
      var fieldset = field ? field.closest('fieldset') : root.querySelector('fieldset[name="' + name + '"]');
      var label = fieldset ? fieldset.querySelector('legend') : null;
      if (!label) label = root.querySelector('[id="label-' + name + '"]');
      if (!label) label = root.querySelector('[id="' + name + '-selector-label"]');
      if (!label && field && field.id) label = root.querySelector('label[for="' + field.id + '"]');
      if (!label || label.querySelector('[data-zheytin-required-marker]')) return;
      if (/\*\s*$/.test(label.textContent || '')) return;

      var marker = document.createElement('span');
      marker.setAttribute('data-zheytin-required-marker', '');
      marker.setAttribute('aria-hidden', 'true');
      marker.textContent = ' *';
      marker.style.color = '#f0d9ac';
      label.appendChild(marker);
    });
  }

  function connectShopifyFormsRequiredMarkers() {
    document.querySelectorAll('shopify-forms-embed').forEach(function(embed) {
      if (!embed.shadowRoot) return;
      markShopifyFormsRequiredFields(embed.shadowRoot);
      if (observedShopifyFormRoots.has(embed.shadowRoot)) return;
      observedShopifyFormRoots.add(embed.shadowRoot);
      new MutationObserver(function() {
        markShopifyFormsRequiredFields(embed.shadowRoot);
      }).observe(embed.shadowRoot, { childList: true, subtree: true });
    });
  }

  connectShopifyFormsRequiredMarkers();
  new MutationObserver(connectShopifyFormsRequiredMarkers).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('shopify-forms-embed').then(connectShopifyFormsRequiredMarkers);
  }

  /* Fix select placeholder color */
  document.querySelectorAll('.zha-select').forEach(function(s){
    s.addEventListener('change', function(){ this.style.color = this.value ? '#f3ebdd' : 'rgba(247,241,230,.28)'; });
  });

  /* Phone formatting */
  var ph = document.getElementById('zha-phone');
  if (ph) {
    ph.addEventListener('input', function(){
      var d = this.value.replace(/\D/g, '');
      if (d.length > 10) d = d.slice(0, 10);
      var f = '';
      if (d.length > 0) f = '(' + d.slice(0, 3);
      if (d.length >= 3) f += ') ';
      if (d.length > 3) f += d.slice(3, 6);
      if (d.length >= 6) f += '-' + d.slice(6, 10);
      this.value = f;
    });
    ph.addEventListener('keydown', function(e){
      if (e.key.length === 1 && !/[0-9]/.test(e.key) && !e.ctrlKey && !e.metaKey && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'Tab') e.preventDefault();
    });
    ph.addEventListener('paste', function(e){
      e.preventDefault();
      var p = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '');
      if (p.length > 10) p = p.slice(0, 10);
      ph.value = p;
      ph.dispatchEvent(new Event('input'));
    });
  }

  /* Other checkbox toggle */
  var oc = document.querySelector('#zha-other-check input'), ow = document.getElementById('zha-other-wrap');
  if (oc && ow) oc.addEventListener('change', function(){
    ow.style.display = this.checked ? 'block' : 'none';
    if (!this.checked) document.getElementById('zha-other-text').value = '';
  });

  /* Social handle: English chars only */
  var si = document.getElementById('zha-social');
  if (si) si.addEventListener('input', function(){ this.value = this.value.replace(/[^a-zA-Z0-9._@\-\/]/g, ''); });

  /* ===== MODAL ===== */
  var SK = "zh_last_submit_ts", MG = 20;
  var ov = document.getElementById("zha-overlay"), md = ov ? ov.querySelector(".zha-modal") : null;
  var floatingApply = document.getElementById("zh-floating-apply");
  var modalScrollY = 0;
  var modalDocumentHeight = 0;
  var pageScrollLocked = false;
  var bodyScrollStyles = {};

  function lockPageScroll() {
    if (pageScrollLocked) return;
    modalScrollY = window.scrollY || window.pageYOffset || 0;
    modalDocumentHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    );
    bodyScrollStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      height: document.body.style.height,
      overflow: document.body.style.overflow
    };
    document.body.style.position = "fixed";
    document.body.style.top = "-" + modalScrollY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.body.style.height = modalDocumentHeight + "px";
    document.body.style.overflow = "hidden";
    pageScrollLocked = true;
  }

  function unlockPageScroll() {
    if (!pageScrollLocked) return;
    document.body.style.position = bodyScrollStyles.position;
    document.body.style.top = bodyScrollStyles.top;
    document.body.style.left = bodyScrollStyles.left;
    document.body.style.right = bodyScrollStyles.right;
    document.body.style.width = bodyScrollStyles.width;
    document.body.style.height = bodyScrollStyles.height;
    document.body.style.overflow = bodyScrollStyles.overflow;
    pageScrollLocked = false;
    window.scrollTo(0, modalScrollY);
  }

  function openM() {
    if (!ov || ov.classList.contains("is-open")) return;
    lockPageScroll();
    ov.style.display = "flex";
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ ov.classList.add("is-open"); }); });
    ov.setAttribute("aria-hidden", "false");
    if (floatingApply) floatingApply.setAttribute("aria-expanded", "true");
  }
  function closeM() {
    if (!ov) return;
    ov.classList.remove("is-open");
    setTimeout(function(){ ov.style.display = "none"; }, 300);
    unlockPageScroll();
    ov.setAttribute("aria-hidden", "true");
    if (floatingApply) floatingApply.setAttribute("aria-expanded", "false");
    resetF();
  }
  function resetF() {
    showS("1"); upBar(1); er("1", ""); er("2", ""); er("3", "");
    var ins = ov.querySelectorAll('input:not([type="checkbox"]):not([type="hidden"]),select');
    ins.forEach(function(el){
      if (el.tagName === 'SELECT') { el.selectedIndex = 0; el.style.color = 'rgba(247,241,230,.28)'; }
      else el.value = '';
    });
    var cbs = ov.querySelectorAll('input[type="checkbox"]');
    cbs.forEach(function(cb){ cb.checked = false; });
    if (ow) ow.style.display = 'none';
  }

  var ab = document.getElementById("zh-apply-btn");
  if (ab) ab.addEventListener("click", function(e){ e.preventDefault(); openM(); });
  if (floatingApply) floatingApply.addEventListener("click", function(e){ e.preventDefault(); openM(); });
  var cbtn = document.getElementById("zha-close");
  if (cbtn) cbtn.addEventListener("click", closeM);
  if (ov) ov.addEventListener("click", function(e){ if (e.target === ov) closeM(); });
  if (ov && ov.dataset.formPosted === "true") { openM(); showS("success"); upBar(3); }
  document.addEventListener("keydown", function(e){ if (e.key === "Escape" && ov && ov.classList.contains("is-open")) closeM(); });

  function showS(n) {
    ["1", "2", "3", "success"].forEach(function(id){ var el = document.getElementById("zha-step-" + id); if (el) el.classList.remove("active"); });
    var s = document.getElementById("zha-step-" + n);
    if (s) s.classList.add("active");
    if (md) md.scrollTop = 0;
  }
  function upBar(step) {
    var dots = document.querySelectorAll(".zha-step-dot"), fills = document.querySelectorAll(".zha-step-line-fill");
    dots.forEach(function(dot, i){
      var s = i + 1;
      dot.classList.remove("is-active", "is-done");
      if (s === step) dot.classList.add("is-active");
      else if (s < step) dot.classList.add("is-done");
    });
    fills.forEach(function(f, i){ f.style.width = (i + 1 < step) ? "100%" : "0"; });
  }
  function er(id, msg) {
    var el = document.getElementById("zha-error-" + id);
    if (!el) return;
    if (msg) { el.textContent = msg; el.classList.add("is-visible"); }
    else { el.textContent = ""; el.classList.remove("is-visible"); }
  }
  function getMot() {
    var items = Array.from(document.querySelectorAll("#zha-motivation input:checked")).map(function(x){ return x.value; });
    var ot = document.getElementById('zha-other-text');
    if (ot && ot.value.trim() && items.indexOf('Other') !== -1) {
      items = items.filter(function(v){ return v !== 'Other'; });
      items.push('Other: ' + ot.value.trim());
    }
    return items;
  }
  function isVE(e) { return /^\S+@\S+\.\S+$/.test(e); }
  function isVP(v) { return v.replace(/\D/g, '').length === 10; }
  function thOk() { try { var l = Number(localStorage.getItem(SK) || "0"); return !l || (Math.floor(Date.now() / 1000) - l) >= MG; } catch(e) { return true; } }
  function setTh() { try { localStorage.setItem(SK, String(Math.floor(Date.now() / 1000))); } catch(e) {} }

  var shopifyFormsEndpoint = 'https://forms.shopifyapps.com/api/v2/form_submission';
  var shopifyFormsCaptchaSiteKey = '2e7f6342-57df-422a-8431-ddd86df296bc';
  var shopifyFormsCaptchaLoader = null;

  function loadShopifyFormsCaptcha() {
    if (window.hcaptcha) return Promise.resolve(window.hcaptcha);
    if (shopifyFormsCaptchaLoader) return shopifyFormsCaptchaLoader;
    shopifyFormsCaptchaLoader = new Promise(function(resolve, reject) {
      var existing = document.getElementById('zha-hcaptcha-api');
      var script = existing || document.createElement('script');
      function ready() {
        if (window.hcaptcha) resolve(window.hcaptcha);
        else reject(new Error('Verification service did not initialize.'));
      }
      script.addEventListener('load', ready, { once: true });
      script.addEventListener('error', function() {
        reject(new Error('Verification service could not be loaded.'));
      }, { once: true });
      if (!existing) {
        script.id = 'zha-hcaptcha-api';
        script.src = 'https://js.hcaptcha.com/1/api.js?render=explicit';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
      }
    });
    return shopifyFormsCaptchaLoader;
  }

  async function getShopifyFormsCaptchaToken() {
    var hcaptcha = await loadShopifyFormsCaptcha();
    return new Promise(function(resolve, reject) {
      var container = document.createElement('div');
      container.className = 'zha-hcaptcha';
      container.style.position = 'absolute';
      container.style.left = '-10000px';
      container.style.top = '0';
      container.style.width = '1px';
      container.style.height = '1px';
      container.style.overflow = 'hidden';
      container.style.opacity = '0';
      container.style.pointerEvents = 'none';
      document.body.appendChild(container);
      var widgetId = null;
      function cleanup() {
        try { if (widgetId !== null) hcaptcha.remove(widgetId); } catch (e) {}
        if (container.parentNode) container.parentNode.removeChild(container);
      }
      widgetId = hcaptcha.render(container, {
        sitekey: shopifyFormsCaptchaSiteKey,
        size: 'invisible',
        callback: function(token) { cleanup(); resolve(token); },
        'close-callback': function() { cleanup(); reject(new Error('Verification was closed. Please try again.')); },
        'error-callback': function() { cleanup(); reject(new Error('Verification failed. Please try again.')); },
        'expired-callback': function() { cleanup(); reject(new Error('Verification expired. Please try again.')); },
        'chalexpired-callback': function() { cleanup(); reject(new Error('Verification expired. Please try again.')); }
      });
      hcaptcha.execute(widgetId);
    });
  }

  /* Step navigation */
  var c1 = document.getElementById("zha-cancel-1");
  if (c1) c1.onclick = closeM;

  var n1 = document.getElementById("zha-next-1");
  if (n1) n1.onclick = function(){
    er("1", "");
    var nm = document.getElementById("zha-fullname").value.trim();
    var p = document.getElementById("zha-phone").value.trim();
    var em = document.getElementById("zha-email").value.trim();
    if (!nm || !p || !em) return er("1", "Please complete all fields.");
    if (!isVP(p)) return er("1", "Please enter a valid 10-digit US phone number.");
    if (!isVE(em)) return er("1", "Please enter a valid email address.");
    showS("2"); upBar(2);
  };

  var b2 = document.getElementById("zha-back-2");
  if (b2) b2.onclick = function(){ showS("1"); upBar(1); };

  var n2 = document.getElementById("zha-next-2");
  if (n2) n2.onclick = function(){
    er("2", "");
    if (!getMot().length) return er("2", "Please select at least one motivation.");
    if (!document.getElementById("zha-purchase").value || !document.getElementById("zha-useolives").value)
      return er("2", "Please select both options.");
    showS("3"); upBar(3);
  };

  var b3 = document.getElementById("zha-back-3");
  if (b3) b3.onclick = function(){ showS("2"); upBar(2); };

  /* ===== SUBMIT ===== */
  var sub = document.getElementById("zha-submit");
  if (sub) sub.onclick = async function(){
    er("3", "");

    /* Honeypot */
    if (document.getElementById("zha-company").value.trim()) { showS("success"); return; }

    /* Throttle */
    if (!thOk()) return er("3", "Please wait a moment and try again.");

    /* Gather fields */
    var fn = document.getElementById("zha-fullname").value.trim();
    var rp = document.getElementById("zha-phone").value.trim();
    var em = document.getElementById("zha-email").value.trim();
    var pd = rp.replace(/\D/g, ''), phone = '+1' + pd;
    var mot = getMot();
    var pf = document.getElementById("zha-purchase").value;
    var of2 = document.getElementById("zha-useolives").value;
    var pu = document.getElementById("zha-primaryuse").value;
    var oi = document.getElementById("zha-organic").value;
    var sp = document.getElementById("zha-social-platform").value;
    var sc = document.getElementById("zha-social").value.trim();
    var ch = document.getElementById("zha-chef").value;
    var nameParts = fn.split(/\s+/).filter(Boolean);
    var firstName = nameParts.shift() || '';
    var lastName = nameParts.join(' ');

    /* Validate */
    if (!fn || !rp || !em) return er("3", "Missing contact details. Go back to Step 1.");
    if (!lastName) return er("3", "Please enter your first and last name.");
    if (!pf || !of2) return er("3", "Missing answers. Go back to Step 2.");
    if (!pu || !oi || !sp || !sc || !ch || !mot.length) return er("3", "Please complete all fields.");

    var btn = document.getElementById("zha-submit");
    var btnSpan = btn.querySelector('span');
    var originalButtonText = btnSpan.textContent;
    btnSpan.innerHTML = '<span class="zha-spinner"></span>Submitting...';
    btn.disabled = true;
    try {
      var captchaToken = await getShopifyFormsCaptchaToken();
      var payload = {
        shopify_domain: (window.Shopify && window.Shopify.shop) || 'zjbaif-8d.myshopify.com',
        form_instance_id: 1133837,
        h_captcha_response: captchaToken,
        first_name: firstName,
        last_name: lastName,
        email: em,
        phone_number: phone,
        'custom#application_motivation': mot.map(function(item) {
          return item.indexOf('Other:') === 0 ? 'Other' : item;
        }),
        'custom#olive_oil_purchase_frequency': pf,
        'custom#olive_oil_use_frequency': of2,
        'custom#primary_olive_oil_use': pu,
        'custom#professional_chef': ch,
        'custom#organic_non_gmo_importance': oi,
        'custom#social_platform': sp,
        'custom#social_handle': sc,
        customer_consented_to_email_marketing: false,
        customer_consented_to_sms_marketing: false
      };
      var response = await fetch(shopifyFormsEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      var result = null;
      try { result = await response.json(); } catch (e) {}
      if (!response.ok) {
        var message = result && result.message ? result.message : 'Could not submit right now. Please try again.';
        throw new Error(message);
      }
      setTh();
      showS("success");
      upBar(3);
    } catch (error) {
      er("3", error && error.message ? error.message : "Could not submit right now. Please try again.");
      btnSpan.textContent = originalButtonText;
      btn.disabled = false;
    }
  };
})();



(function() {
  var section = document.querySelector('.zhfaq');
  if (!section) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Accordion ── */
  var items = section.querySelectorAll('[data-zhfaq]');
  items.forEach(function(item) {
    var btn = item.querySelector('.zhfaq-q');
    if (!btn) return;

    btn.addEventListener('click', function() {
      var isOpen = item.classList.contains('is-open');

      items.forEach(function(other) {
        if (other !== item && other.classList.contains('is-open')) {
          other.classList.remove('is-open');
          other.querySelector('.zhfaq-q').setAttribute('aria-expanded', 'false');
        }
      });

      if (isOpen) {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Scroll reveal ── */
  if (reduceMotion) {
    section.classList.add('is-visible');
  } else {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        section.classList.add('is-visible');
        observer.unobserve(section);
      });
    }, { threshold: 0.12 });
    observer.observe(section);
  }
})();
